export default "__VITE_ASSET__CpzJyO07__"